import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";

import { FaShieldAlt, FaBug, FaSearch, FaLock, FaNetworkWired, FaFileCode, FaUserSecret, FaClipboardCheck } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const serviceCards = [
    {
        icon: <FaSearch size={80} color="var(--brand-primary)" />,
        title: "Vulnerability Assessment",
        description: "Comprehensive scanning and analysis to identify security weaknesses in your applications, networks, and infrastructure. We provide detailed reports with risk ratings and remediation guidance.",
    },
    {
        icon: <FaBug size={80} color="var(--brand-primary)" />,
        title: "Penetration Testing",
        description: "Ethical hacking to simulate real-world attacks and uncover exploitable vulnerabilities. Our certified security experts test your defenses and provide actionable recommendations.",
    },
    {
        icon: <FaFileCode size={80} color="var(--brand-primary)" />,
        title: "Secure Code Review",
        description: "Manual and automated code analysis to identify security flaws before deployment. We review your codebase for OWASP Top 10 vulnerabilities and coding best practices.",
    },
    {
        icon: <FaNetworkWired size={80} color="var(--brand-primary)" />,
        title: "Network Security Assessment",
        description: "Evaluate your network infrastructure for misconfigurations, weak points, and potential attack vectors. We test firewalls, routers, and network segmentation.",
    },
    {
        icon: <FaLock size={80} color="var(--brand-primary)" />,
        title: "Security Architecture Review",
        description: "Assess your overall security architecture and design for gaps and weaknesses. We provide strategic recommendations to strengthen your security posture.",
    },
    {
        icon: <FaUserSecret size={80} color="var(--brand-primary)" />,
        title: "Social Engineering Testing",
        description: "Test your team's security awareness through simulated phishing campaigns and social engineering attacks. We help build a security-conscious culture.",
    },
    {
        icon: <FaClipboardCheck size={80} color="var(--brand-primary)" />,
        title: "Compliance & Standards",
        description: "Ensure compliance with industry standards like ISO 27001, PCI DSS, GDPR, and HIPAA. We help you meet regulatory requirements and maintain certifications.",
    },
    {
        icon: <FaShieldAlt size={80} color="var(--brand-primary)" />,
        title: "Secure-by-Design Development",
        description: "Integrate security into every phase of your development lifecycle. We implement security best practices, threat modeling, and secure coding standards from day one.",
    },
];

const CyberSecurityVAPT = () => {
    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
                <title>Cyber Security & VAPT - Syrol Tech</title>
                <meta name="description" content="Comprehensive security services including vulnerability assessment, penetration testing, and secure-by-design development practices to protect systems and data." />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />
            <SiteBreadcrumb
                pageTitle="Cyber Security & VAPT"
                pageName="Cyber Security & VAPT"
                breadcrumbsImg={bannerbg}
            />
            <section className="consultation-hero-section position-relative w-100" style={{ minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat` }}>
                <div className="hero-overlay" style={{ position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1 }}></div>
                <div className="container position-relative" style={{ zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left' }}>
                    <h1 style={{ color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem' }}>Protect your systems with comprehensive security services</h1>
                    <p style={{ color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem' }}>Comprehensive security services including vulnerability assessment, penetration testing, and secure-by-design development practices to protect systems and data.</p>
                    <Link to="/consultation" className="readon orange-btn" style={{ padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', transition: 'background 0.2s' }}>Request A Free Proposal</Link>
                </div>
            </section>
            <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
                <div className="container pb-66 md-pb-46">
                    <h2 className="service-title mb-32">Our Cyber Security & VAPT Services</h2>
                    {serviceCards.map((card, idx) => (
                        <ServiceCard
                            key={idx}
                            icon={card.icon}
                            title={card.title}
                            description={card.description}
                        />
                    ))}
                </div>
            </div>
            <IndustriesSection />
            <Newsletter
                sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
                titleClass="title mb-0 white-color"
            />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />
        </React.Fragment>
    );
};

export default CyberSecurityVAPT;
